import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { readImpersonation } from "@/components/ImpersonationBanner";
import { ShieldAlert } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

// role: "partner" | "b2c"
export default function SupportSessionBanner({ role = "b2c" }) {
  const { t } = useLang();
  const [active, setActive] = useState(false);
  const [busy, setBusy] = useState(false);
  const path = role === "partner" ? "/auth/me/support-session" : "/b2c/support-session";
  const isB2c = role === "b2c";

  async function check() {
    // Hide for the admin who is currently impersonating (they use the red banner).
    if (readImpersonation()) { setActive(false); return; }
    try {
      const r = await api(path, { b2c: isB2c });
      setActive(!!r.active);
    } catch { setActive(false); }
  }
  useEffect(() => { check(); /* eslint-disable-next-line */ }, []);

  async function revoke() {
    setBusy(true);
    try {
      await api(`${path}/revoke`, { method: "POST", b2c: isB2c });
      toast.success(t("hc.assistanceSessionRevoked"));
      setActive(false);
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  }

  if (!active) return null;
  return (
    <div className="bg-amber-500 text-white px-6 py-3" data-testid="support-session-banner">
      <div className="max-w-5xl mx-auto flex items-center justify-between gap-4 text-sm">
        <p className="flex items-center gap-2 font-semibold"><ShieldAlert size={16} /> {t("hc.aFindoAssistanceSessionIs")}</p>
        <button onClick={revoke} disabled={busy}
          className="rounded-full bg-white/25 hover:bg-white/35 px-4 py-1.5 font-semibold whitespace-nowrap transition-colors"
          data-testid="support-session-revoke">
          {t("hc.revokeAccess")}
        </button>
      </div>
    </div>
  );
}
